"use client";

import { c as _c } from "react/compiler-runtime";
export default function BlockPickerBlockNumberIncludes(t0) {
  const $ = _c(8);
  const {
    disabled,
    blockNumberIncludes,
    setBlockNumberIncludes
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <label className="tw-block tw-text-sm tw-font-normal tw-leading-5 tw-text-iron-100">Block number includes</label>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = disabled ? "Select a time window" : "e.g. 42, 69, 42069, 6529";
  let t3;
  if ($[1] !== setBlockNumberIncludes) {
    t3 = e => setBlockNumberIncludes(e.target.value);
    $[1] = setBlockNumberIncludes;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== blockNumberIncludes || $[4] !== disabled || $[5] !== t2 || $[6] !== t3) {
    t4 = <div className="tw-w-full">{t1}<div className="tw-relative tw-mt-1.5"><input disabled={disabled} type="text" name="block-number-includes" id="block-number-includes" value={blockNumberIncludes} required={true} placeholder={t2} autoComplete="off" onChange={t3} className="tw-form-input tw-block tw-w-full tw-rounded-lg tw-border-0 tw-py-3 tw-px-3 tw-bg-iron-700/40 tw-text-white tw-font-light tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700/40 placeholder:tw-text-iron-500  focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 hover:tw-ring-iron-700 tw-text-base sm:tw-leading-6 tw-transition tw-duration-300 tw-ease-out" /></div></div>;
    $[3] = blockNumberIncludes;
    $[4] = disabled;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}